import { render, staticRenderFns } from "./ScrollingDocument.vue?vue&type=template&id=537e8550&"
import script from "./ScrollingDocument.vue?vue&type=script&lang=js&"
export * from "./ScrollingDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports